import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { BREAKPOINTS } from '@constants/common'
import { WindowSizeContext } from '@context/WindowSize/Context'
import { Slugs } from '@type/buzzkuri/programs-categor'
import React, { useContext } from 'react'
import { CategoryFeaturesContent } from './Content'

type Props = {
  features: string
  slugs: Slugs
}

export const CategoryFeatures = ({ features, slugs }: Props): JSX.Element => {
  const winSize = useContext(WindowSizeContext)
  const [ slug ] = slugs

  return (
    <div className="lg:w-[65.2vw]">
      <ProgramDescriptionAccordion
        title={
          winSize?.width > BREAKPOINTS.laptop
            ? `バヅクリにおける${slug}の特徴`
            : `バヅクリにおける${slug}\n研修の特徴`
        }
      >
        <CategoryFeaturesContent {...{ features, slugs }} />
      </ProgramDescriptionAccordion>
    </div>
  )
}
